<div class="px-6 py-4 border-b border-gray-100 bg-white flex flex-row justify-between items-center">
  <div>
    <h1 class="text-xl font-bold text-gray-900">{{ isEdit ? 'Update customer' : 'New customer' }}</h1>
    <p class="text-xs text-gray-400 mt-0.5">{{ isEdit ? data.customer.useremail : 'Creates the account - they set their own password from the login page.' }}</p>
  </div>
  <button type="button" (click)="dialogRef.close({status: false})" class="h-9 w-9 rounded-full bg-gray-100 text-gray-500 hover:bg-gray-200 hover:text-gray-800 flex items-center justify-center text-sm transition-colors" matTooltip="Close" aria-label="Close">✕</button>
</div>

<mat-dialog-content class="mat-typography !px-6 !py-5 overflow-x-hidden">
  <form [formGroup]="createCustomerForm" (ngSubmit)="onSubmit()">
    <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">

      <!-- First name -->
      <div>
        <label class="text-[11px] font-semibold text-gray-500 uppercase tracking-wider">First name *</label>
        <input class="mt-1.5 w-full px-3 py-2.5 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:border-amber-400 focus:ring-4 focus:ring-amber-100 outline-none transition-all text-sm disabled:opacity-60 disabled:cursor-not-allowed" name="customer-first-name" type="text" placeholder="First name" formControlName="firstname" trimInput />
        @if (f['firstname'].invalid && (f['firstname'].dirty || f['firstname'].touched)) {
            <div class="mt-1 text-xs text-red-600">@if (f['firstname'].errors?.['required']) { <span>First name is required</span> } @if (f['firstname'].errors?.['minlength']) { <span>At least 2 characters</span> } @if (f['firstname'].errors?.['maxlength']) { <span>200 characters at most</span> }</div>
          }
      </div>

      <!-- Last name -->
      <div>
        <label class="text-[11px] font-semibold text-gray-500 uppercase tracking-wider">Last name *</label>
        <input class="mt-1.5 w-full px-3 py-2.5 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:border-amber-400 focus:ring-4 focus:ring-amber-100 outline-none transition-all text-sm disabled:opacity-60 disabled:cursor-not-allowed" name="customer-last-name" type="text" placeholder="Last name" formControlName="lastname" trimInput />
        @if (f['lastname'].invalid && (f['lastname'].dirty || f['lastname'].touched)) {
            <div class="mt-1 text-xs text-red-600">@if (f['lastname'].errors?.['required']) { <span>Last name is required</span> } @if (f['lastname'].errors?.['minlength']) { <span>At least 2 characters</span> } @if (f['lastname'].errors?.['maxlength']) { <span>200 characters at most</span> }</div>
          }
      </div>

      <!-- Email (only when creating) -->
      @if (!isEdit) {
      <div class="sm:col-span-2">
        <label class="text-[11px] font-semibold text-gray-500 uppercase tracking-wider">Email *</label>
        <input class="mt-1.5 w-full px-3 py-2.5 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:border-amber-400 focus:ring-4 focus:ring-amber-100 outline-none transition-all text-sm disabled:opacity-60 disabled:cursor-not-allowed" name="customer-email" type="email" placeholder="name@example.com" formControlName="useremail" trimInput />
        @if (f['useremail'].invalid && (f['useremail'].dirty || f['useremail'].touched)) {
            <div class="mt-1 text-xs text-red-600">@if (f['useremail'].errors?.['required']) { <span>Email is required</span> } @if (f['useremail'].errors?.['email']) { <span>That is not a valid email address</span> }</div>
          }
      </div>
      }

      <!-- Display name -->
      <div>
        <label class="text-[11px] font-semibold text-gray-500 uppercase tracking-wider">Display name / company</label>
        <input class="mt-1.5 w-full px-3 py-2.5 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:border-amber-400 focus:ring-4 focus:ring-amber-100 outline-none transition-all text-sm disabled:opacity-60 disabled:cursor-not-allowed" name="customer-display-name" type="text" placeholder="e.g. JCR Landscapes" formControlName="displayname" trimInput />
        @if (f['displayname'].invalid && (f['displayname'].dirty || f['displayname'].touched)) {
            <div class="mt-1 text-xs text-red-600">@if (f['displayname'].errors?.['minlength']) { <span>At least 2 characters</span> } @if (f['displayname'].errors?.['maxlength']) { <span>300 characters at most</span> }</div>
          }
      </div>

      <!-- Phone -->
      <div>
        <label class="text-[11px] font-semibold text-gray-500 uppercase tracking-wider">Phone</label>
        <input class="mt-1.5 w-full px-3 py-2.5 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:border-amber-400 focus:ring-4 focus:ring-amber-100 outline-none transition-all text-sm disabled:opacity-60 disabled:cursor-not-allowed" name="customer-phone" type="tel" placeholder="07123 456789 or +44 7123 456789" formControlName="phone" trimInput />
        @if (f['phone'].invalid && (f['phone'].dirty || f['phone'].touched)) {
            <div class="mt-1 text-xs text-red-600">@if (f['phone'].errors?.['pattern']) { <span>Use digits, spaces, + ( ) or - (7 to 20 characters)</span> }</div>
          }
      </div>

      <!-- VAT number -->
      <div>
        <label class="text-[11px] font-semibold text-gray-500 uppercase tracking-wider">VAT number</label>
        <input class="mt-1.5 w-full px-3 py-2.5 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:border-amber-400 focus:ring-4 focus:ring-amber-100 outline-none transition-all text-sm disabled:opacity-60 disabled:cursor-not-allowed uppercase" name="customer-vat-number" type="text" placeholder="GB123456789" formControlName="vatnumber"
          pattern="^GB(\d{3} \d{4} \d{2}|\d{9}|\d{9} \d{3}|GD([0-4][0-9]{2})|HA([5-9][0-9]{2}))$" trimInput />
        @if (f['vatnumber'].invalid) { <div class="mt-1 text-xs text-red-600">Not a valid UK VAT number (e.g. GB123456789)</div> }
      </div>

      <!-- Membership tier -->
      @if (canSetType) {
      <div>
        <label class="text-[11px] font-semibold text-gray-500 uppercase tracking-wider">Membership</label>
        <select class="mt-1.5 w-full px-3 py-2.5 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:border-amber-400 focus:ring-4 focus:ring-amber-100 outline-none transition-all text-sm disabled:opacity-60 disabled:cursor-not-allowed cursor-pointer" name="customer-usertype" formControlName="usertype">
          <option value="NONMEMBER">Non member</option>
          <option value="BRONZE">Bronze member</option>
          <option value="SILVER">Silver member</option>
          <option value="GOLD">Gold member</option>
          <option value="PLATINUM">Platinum member</option>
        </select>
        <p class="mt-1 text-[11px] text-gray-400">Any tier other than Non member makes them a trade account.</p>
      </div>
      }
    </div>

    <div class="mt-6 pt-5 border-t border-gray-100 flex flex-row justify-end gap-3">
      <button type="reset" (click)="dialogRef.close({status: false})"
        class="px-5 py-2.5 rounded-xl border border-gray-200 bg-white text-gray-700 text-sm font-semibold hover:bg-gray-50 transition-colors">Cancel</button>
      <button type="submit"
        class="flex items-center gap-2 px-6 py-2.5 rounded-xl bg-gradient-to-b from-amber-400 to-amber-500 text-neutral-900 font-bold text-sm shadow-md shadow-amber-200 hover:from-amber-300 hover:to-amber-400 active:scale-[0.98] transition-all">
        {{ isEdit ? 'Update customer' : 'Create customer' }}
      </button>
    </div>
  </form>

  <!-- Super admin only; kept outside the form so Enter in its box never submits the customer form. -->
  @if (isEdit) {
  <div class="mt-6">
    <app-set-password [userId]="data.customer.userid" [name]="data.customer.firstname || 'this customer'"></app-set-password>
  </div>
  }
</mat-dialog-content>
